module.exports = __webpack_public_path__ + "static/img/logoTxt.4c447406.png";